; (function () {
  const initialAccessibilityBtnBottomPosition = window.location.pathname.includes('/products/') ? 75 : 24
  const stickyAddToCartBtnHeight = 52
  const INDmenuBtnAltBottom = 135

  let isAccessibilityBtnPositionChanged = false

  if (window.location.pathname.includes('/products/') && !isINDdragged() && !isAccessibilityBtnPositionChanged) {
    waitForElement('.INDMobile #INDmenu-btn').then(INDmenuBtn => {
      INDmenuBtn.style.bottom = '75px'
    })
  }

  watchForOffElement('.needsclick.kl-teaser-T4UsqC.kl-private-reset-css-Xuajs1',
    saleBtn => {
      const INDmenuBtn = document.querySelector('.INDMobile #INDmenu-btn')
      if (INDmenuBtn) {
        if (window.location.pathname.includes('/products/')) {
          saleBtn.style.bottom = `${stickyAddToCartBtnHeight}px`
          if (!isINDdragged()) {
            isAccessibilityBtnPositionChanged = true
            INDmenuBtn.style.bottom = `${INDmenuBtnAltBottom + stickyAddToCartBtnHeight}px`
          }
        } else {
          if (!isINDdragged()) {
            isAccessibilityBtnPositionChanged = true
            INDmenuBtn.style.bottom = `${INDmenuBtnAltBottom}px`
          }
        }
      }
    },
    () => {
      const INDmenuBtn = document.querySelector('.INDMobile #INDmenu-btn')
      if (INDmenuBtn && !isINDdragged()) {
        isAccessibilityBtnPositionChanged = true
        INDmenuBtn.style.bottom = `${initialAccessibilityBtnBottomPosition}px`
      }
    }
  )

  function watchForOffElement(selector, onAppear, onDisappear) {
    let elementFound = document.querySelector(selector) !== null

    // Immediately invoke onAppear if the element already exists
    if (elementFound) {
      onAppear(document.querySelector(selector))
    }

    const observer = new MutationObserver((mutationsList, observer) => {
      // Check for added nodes on each mutation
      for (const mutation of mutationsList) {
        if (mutation.addedNodes.length) {
          const addedElement = Array.from(mutation.addedNodes).find(node => node.nodeType === 1 && node.matches(selector))
          if (addedElement && !elementFound) {
            elementFound = true
            onAppear(addedElement)
          }
        }

        // Check for removed nodes on each mutation
        if (mutation.removedNodes.length) {
          const removedElement = Array.from(mutation.removedNodes).find(node => node.nodeType === 1 && node.matches(selector))
          if (removedElement && elementFound) {
            elementFound = false
            onDisappear(removedElement)
          }
        }
      }
    })

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    })
  }

  function waitForElement(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector))
      }

      const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector))
          observer.disconnect()
        }
      })

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true
      })
    })
  }

  function isINDdragged() {
    return localStorage.getItem('INDbtnPosition') ? true : false
  }
})()